<h1 mat-dialog-title class="pt-2 text-center"> Changement de mesure</h1>
<div mat-dialog-content class="p-0">
    <div class="container no-gutters">

        <div class="row m-0">
            <mat-form-field class="col">
                <mat-select placeholder="Mesure" [(ngModel)]="SelectedMeasureRef">
                    @for (ref of MeasureReferenceList; track ref; let i = $index) {
                    <mat-option [value]="ref">
                        {{ ref.Designation }}
                    </mat-option>
                    }
                </mat-select>
            </mat-form-field>
        </div>
        <div class="row m-1">
            <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
                Annuler
            </button>
            <button appPreventDoubleClick class="col ms-1" mat-raised-button color="primary" (throttledClick)="finish()">
                Ajouter
            </button>
        </div>
    </div>
</div>